import { render, staticRenderFns } from "./tokenRelease.vue?vue&type=template&id=405ae487"
import script from "./tokenRelease.vue?vue&type=script&lang=js"
export * from "./tokenRelease.vue?vue&type=script&lang=js"
import style0 from "./tokenRelease.vue?vue&type=style&index=0&id=405ae487&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports